function ascArray(n) {
    return Array.from(new Array(n), (x,i) => i + 1)
}
function descArray(n) {
    return Array.from(new Array(n), (x,i) => i + 1).reverse()
}
export const cognitive = [
    {'02': 4},
    {'04': 8},
    {'08': 8},
    {'12': 2},
    {'15': 5},
    
    {'18': 2},
    {'20': 5},
    {'24': 7},
    {'30': 3},
    {'32': 4},
    
    {'34': 6},
    {'37': 4},
    {'38': 3},
    {'40': 3},
    {'47': 3},

]
export const personality = [
    {'ฉันหาเพื่อนใหม่ได้ง่าย':{'trait': 'extraversion','score': ascArray(5)}},
    {'ฉันรู้สึกเห็นใจคนที่มีชีวิตลำบากกว่าฉัน':{'trait': 'agreeableness','score': ascArray(5)}},
    {'ฉันชอบอยู่ท่ามกลางผู้คน':{'trait': 'extraversion','score': ascArray(5)}},
    {'ฉันไม่ผัดวันประกันพรุ่ง':{'trait': 'conscientiousness','score': ascArray(5)}},
    {'ฉันกล้าแสดงความคิดเห็นในห้องเรียน':{'trait': 'extraversion','score': ascArray(5)}},

    {'ฉันเชื่อว่าทุกคนล้วนมีเจตนาดีต่อกัน':{'trait': 'agreeableness','score': ascArray(5)}},
    {'ฉันชอบพักผ่อนอยู่เฉยๆ ในเวลาว่าง':{'trait': 'extraversion','score': descArray(5)}},
    {'ฉันเรียนหนักจนกว่าจะประสบความสำเร็จ':{'trait': 'mastery','score': ascArray(5)}},
    {'ฉันสนุกกับการหาช่องโหว่ในกฎกติกา':{'trait': 'agreeableness','score': descArray(5)}},
    {'ฉันไม่ล้อเลียนเพื่อนฝูง':{'trait': 'agreeableness','score': ascArray(5)}},

    {'ฉันตั้งใจทำการบ้านเพื่อให้ไม่มีข้อผิดพลาด':{'trait': 'conscientiousness','score': ascArray(5)}},
    {'ฉันเป็นคนชอบลงมือก่อน คิดทีหลัง':{'trait': 'conscientiousness','score': descArray(5)}},
    {'ฉันอ่านหนังสือหลากหลายประเภท':{'trait': 'desireToLearn','score': ascArray(5)}},
    {'ฉันต้องการเรียนรู้สิ่งใหม่ๆ อยู่เสมอ':{'trait': 'desireToLearn','score': ascArray(5)}},
    {'ฉันไม่ชอบออกจากสภาวะที่ตนเองคุ้นเคย':{'trait': 'desireToLearn','score': descArray(5)}},

    {'ฉันพัฒนาตนเองอยู่เสมอแม้ฉันจะทำมันได้ดีแล้ว':{'trait': 'mastery','score': ascArray(5)}},
    {'ห้องนอนของฉันสะอาดและเป็นระเบียบ':{'trait': 'conscientiousness','score': ascArray(5)}},
    {'ฉันตั้งเป้าหมายที่พอดีๆ เพื่อไม่กดดันตนเอง':{'trait': 'mastery','score': descArray(5)}},
    {'ฉันพยายามมากขึ้นหากต้องแข่งขันกับผู้อื่น':{'trait': 'otherReferencedGoals','score': ascArray(5)}},
    {'ฉันศึกษาบทเรียนลึกกว่าที่ครูสอนในห้อง':{'trait': 'mastery','score': ascArray(5)}},
    
    {'ฉันชอบหาความรู้เพิ่มเติมในสิ่งที่ครูไม่ได้สอน':{'trait': 'desireToLearn','score': ascArray(5)}},
    {'ฉันยินดีกับความสำเร็จของผู้อื่น':{'trait': 'otherReferencedGoals','score': descArray(5)}},
    {'ฉันต้องการประสบความสำเร็จเหนือผู้อื่น':{'trait': 'otherReferencedGoals','score': ascArray(5)}},
    {'ฉันทำให้คนรอบข้างผิดหวังอยู่บ่อยครั้ง':{'trait': 'selfEfficacy','score': descArray(5)}},
    {'ฉันหาอะไรมาแข่งขันกับเพื่อนๆ อยู่เสมอ':{'trait': 'competitiveness','score': ascArray(5)}},

    {'ฉันเป็นคนไม่ชอบการแข่งขัน':{'trait': 'competitiveness','score': descArray(5)}},
    {'ฉันไม่กังวลเกี่ยวกับความล้มเหลวที่อาจจะเกิดขึ้น':{'trait': 'worry','score': ascArray(5)}},
    {'การแข่งขันทำให้ฉันตั้งใจมากขึ้น':{'trait': 'competitiveness','score': ascArray(5)}},
    {'ฉันมักทำผลงานได้ดีในสถานการณ์การแข่งขัน':{'trait': 'competitiveness','score': ascArray(5)}},
    {'ฉันไม่คิดกังวลเกี่ยวกับสิ่งที่เกิดขึ้นแล้ว':{'trait': 'worry','score': ascArray(5)}},

    {'ฉันไม่อ่อนไหวไปกับอารมณ์ชั่ววูบ':{'trait': 'emotionality','score': ascArray(5)}},
    {'ความรับผิดชอบมากมายทำให้ฉันกดดัน':{'trait': 'emotionality','score': descArray(5)}},
    {'ฉันปกป้องตนเองอย่างเต็มที่หากถูกรังแก':{'trait': 'selfEfficacy','score': ascArray(5)}},
    {'ฉันกังวลว่าผู้อื่นจะเห็นข้อบกพร่องของฉัน':{'trait': 'worry','score': descArray(5)}},
    {'ฉันนอนหลับได้ปกติ แม้มีงานสำคัญรออยู่ในวันรุ่งขึ้น':{'trait': 'worry','score': ascArray(5)}},
    
    {'ฉันผิดหวังหากเห็นผู้อื่นทำอะไรได้ดีกว่าตนเอง':{'trait': 'otherReferencedGoals','score': ascArray(5)}},
    {'ฉันไม่รู้สึกประหม่าก่อนการสอบครั้งสำคัญ':{'trait': 'emotionality','score': ascArray(5)}},
    {'ฉันรู้สึกผ่อนคลาย แม้รู้ว่ากำลังมีคนมองฉันอยู่':{'trait': 'emotionality','score': ascArray(5)}},
    {'ฉันตัดสินใจสิ่งต่างๆ ในชีวิตด้วยตนเอง':{'trait': 'selfEfficacy','score': ascArray(5)}},
    {'ฉันจัดการกับอุปสรรคต่างๆ ในชีวิตได้เสมอ':{'trait': 'selfEfficacy','score': ascArray(5)}},
]

export const softskills = [
    {'ฉันไม่ถนัดการนำเสนองานหน้าชั้น':{'trait': 'CPN','score': descArray(5)}},
    {'ฉันช่วยเหลือเพื่อนๆ ให้มีความก้าวหน้าในการเรียน':{'trait': 'PPM','score': ascArray(5)}},
    {'ฉันตัดสินใจได้อย่างเด็ดขาด แม้ในสถานการณ์กดดัน':{'trait': 'LOM','score': ascArray(5)}},
    {'เมื่อมีปัญหา ฉันหาทางออกที่ทุกฝ่ายพอใจได้เสมอ':{'trait': 'CPN','score': ascArray(5)}},

    {'ในการทำงานกลุ่ม ฉันสนใจเฉพาะงานส่วนของฉันเอง':{'trait': 'PPM','score': descArray(5)}},
    {'ฉันเปิดใจกับมุมมองที่แตกต่าง':{'trait': 'PIS','score': ascArray(5)}},
    {'ฉันประเมินตนเองเพื่อหาทางพัฒนาให้ดีขึ้น':{'trait': 'PPM','score': ascArray(5)}},
    {'ฉันสามารถโน้มน้าวให้ผู้อื่นทำในสิ่งที่ฉันต้องการ':{'trait': 'CPN','score': ascArray(5)}},

    {'ฉันเป็นคนตัดสินใจแน่วแน่ ไม่ละล้าละลัง':{'trait': 'SMC','score': ascArray(5)}},
    {'ฉันรับผิดชอบในงาน ไม่ต้องให้ใครมาจ้ำจี้จ้ำไช':{'trait': 'SMC','score': ascArray(5)}},
    {'ฉันเป็นคนมีโลกส่วนตัวสูง เข้าถึงยาก':{'trait': 'PIS','score': descArray(5)}},
    {'ปัญหาส่วนตัวของฉันไม่ส่งผลเสียต่อการเรียน':{'trait': 'SMC','score': ascArray(5)}},
    
    {'ฉันทำงานร่วมกับผู้อื่นได้ดี':{'trait': 'PIS','score': ascArray(5)}},
    {'ในการทำงานกลุ่ม ฉันเป็นผู้ตามมากกว่าผู้นำ':{'trait': 'LOM','score': descArray(5)}},
    {'ในการทำงานกลุ่ม ฉันมักเป็นคนคอยประสานงาน':{'trait': 'PIS','score': ascArray(5)}},
    {'ฉันรู้จุดแข็งและจุดอ่อนของเพื่อนแต่ละคน':{'trait': 'PPM','score': ascArray(5)}},

    {'ฉันวางแผนและบริหารเวลาของตนเองเป็นอย่างดี':{'trait': 'LOM','score': ascArray(5)}},
    {'ฉันคิดอย่างรอบคอบก่อนการตัดสินใจแต่ละครั้ง':{'trait': 'LOM','score': ascArray(5)}},
    {'ฉันเป็นคนอารมณ์ร้อน':{'trait': 'SMC','score': descArray(5)}},
    {'ฉันสามารถอธิบายเรื่องยากๆ ให้เข้าใจได้ง่าย':{'trait': 'CPN','score': ascArray(5)}},

    {'ฉันปรับวิธีการสื่อสารให้เข้ากับสถานการณ์และผู้ฟัง':{'trait': 'PCS','score': ascArray(5)}},
    {'ฉันไม่เปิดเผยความลับของเพื่อนให้ผู้อื่นรับรู้':{'trait': 'PEW','score': ascArray(5)}},
    {'ฉันสนุกกับการซุบซิบนินทาในกลุ่มเพื่อน':{'trait': 'PEW','score': descArray(5)}},
    {'ฉันเปิดใจรับฟังคำวิจารณ์ แม้จะไม่เห็นด้วยนักก็ตาม':{'trait': 'PCS','score': ascArray(5)}},

    {'ฉันเป็นคนตรงไปตรงมาและซื่อสัตย์ต่อทุกคน':{'trait': 'PEW','score': ascArray(5)}},
    {'ฉันปรับตัวเข้ากับสถานการณ์ที่เปลี่ยนแปลงได้ดี':{'trait': 'PCS','score': ascArray(5)}},
    {'ภาพลักษณ์ที่ดีของโรงเรียนไม่ใช่เรื่องของฉัน':{'trait': 'PCS','score': descArray(5)}},
    {'ในการทำงานกลุ่ม ฉันทำงานเต็มที่ ไม่เอาเปรียบใคร':{'trait': 'PEW','score': ascArray(5)}},
    
]

export const wp = [
    {'ประกอบเฟอร์นิเจอร์กึ่งสำเร็จรูป':{'trait': 'WPPM','score': ascArray(5)}},
    {'หาคำอธิบายของปรากฏการณ์ต่างๆ':{'trait': 'WIAM','score': ascArray(5)}},
    {'ตกแต่งบ้านสำหรับโอกาสพิเศษ':{'trait': 'WPPM','score': ascArray(5)}},
    {'แนะแนวหรือให้คำปรึกษาแก่ผู้อื่น':{'trait': 'WICH','score': ascArray(5)}},
    {'เรียนรู้การดูดาวและดาราศาสตร์':{'trait': 'WIAM','score': ascArray(5)}},

    {'เรียนรู้โปรแกรมคอมพิวเตอร์ใหม่ๆ':{'trait': 'WIAM','score': ascArray(5)}},
    {'ดูแลเด็กหรือบุคคลพิการ':{'trait': 'WICH','score': ascArray(5)}},
    {'วางกลยุทธ์การทำงานหรือแผนธุรกิจ':{'trait': 'WPAM','score': ascArray(5)}},
    {'วิเคราะห์ข้อมูลเชิงสถิติ':{'trait': 'WIAM','score': ascArray(5)}},
    {'ซ่อมแซมอุปกรณ์อิเล็กทรอนิกส์':{'trait': 'WPPM','score': ascArray(5)}},

    {'ออกแบบบ้านในฝันของตนเอง':{'trait': 'WCII','score': ascArray(5)}},
    {'ทำอาหารหรือขนมรับประทานเอง':{'trait': 'WPPM','score': ascArray(5)}},
    {'ร้องเพลงหรือเล่นดนตรี':{'trait': 'WCII','score': ascArray(5)}},
    {'อาสาสมัครทำประโยชน์เพื่อสังคม':{'trait': 'WICH','score': ascArray(5)}},
    {'โพสรูปที่ไม่เหมือนใครลงโซเชียลมีเดีย':{'trait': 'WCII','score': ascArray(5)}},
    
    {'สอนหรือถ่ายทอดความรู้แก่ผู้อื่น':{'trait': 'WICH','score': ascArray(5)}},
    {'ซ่อมแซมเฟอร์นิเจอร์ในบ้าน':{'trait': 'WPPM','score': ascArray(5)}},
    {'อ่านรีวิวสินค้าและบริการก่อนตัดสินใจซื้อ':{'trait': 'WCEO','score': ascArray(5)}},
    {'สร้างความสนิทสนมกับเพื่อนต่างแดน':{'trait': 'WICH','score': ascArray(5)}},
    {'เสนอขายสินค้าหรือบริการแก่ผู้อื่น':{'trait': 'WPAM','score': ascArray(5)}},

    {'เป็นผู้นำการประชุมหรือสัมมนา':{'trait': 'WPAM','score': ascArray(5)}},
    {'เจรจาต่อรองราคาสินค้าหรือบริการ':{'trait': 'WPAM','score': ascArray(5)}},
    {'จัดระเบียบข้อมูลและเอกสารสำคัญ':{'trait': 'WCEO','score': ascArray(5)}},
    {'สร้างแรงบันดาลใจให้ผู้อื่นตั้งใจทำงาน':{'trait': 'WPAM','score': ascArray(5)}},
    {'ถ่ายภาพบุคคลหรือวิวทิวทัศน์':{'trait': 'WCII','score': ascArray(5)}},

    {'ทำบัญชีรายรับรายจ่าย':{'trait': 'WCEO','score': ascArray(5)}},
    {'ตรวจตราความถูกต้องของเอกสารสำคัญ':{'trait': 'WCEO','score': ascArray(5)}},
    {'แก้ไขและเรียบเรียงรายงานกลุ่ม':{'trait': 'WCEO','score': ascArray(5)}},
    {'เขียนบทความหรือแต่งเพลงถึงผู้อื่น':{'trait': 'WCII','score': ascArray(5)}},
    {'เล่นเกมส์ฝึกทักษะการคิด':{'trait': 'WIAM','score': ascArray(5)}},




    
    
]


// WEBPACK FOOTER //
// ./src/testPool.js